import { render } from "./Hospitals.vue?vue&type=template&id=71204bf4&scoped=true"
import script from "./Hospitals.vue?vue&type=script&lang=js"
export * from "./Hospitals.vue?vue&type=script&lang=js"

import "./Hospitals.vue?vue&type=style&index=0&id=71204bf4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71204bf4"]])

export default __exports__